import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7dc37b1f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal-backdrop"
}
const _hoisted_2 = {
  ref: "modalContent",
  class: "modal-content"
}
const _hoisted_3 = { class: "errorform" }
const _hoisted_4 = {
  key: 0,
  class: "error-message"
}
const _hoisted_5 = {
  key: 0,
  class: "modal-footer"
}
const _hoisted_6 = { class: "com_mgt10" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text__item" }, "閉じる"),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text__item",
    "aria-hidden": "true"
  }, "閉じる")
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  ref: "modalContent",
  class: "modal-content",
  id: "contents1"
}
const _hoisted_10 = {
  key: 0,
  class: "error-message",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 1,
  class: "com_d_content1"
}
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = {
  key: 2,
  class: "com_links1"
}
const _hoisted_15 = {
  key: 0,
  class: "item1"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "リンク")
], -1))
const _hoisted_17 = ["href", "onClick"]
const _hoisted_18 = {
  key: 1,
  class: "item1"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "文書ファイル", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "全データダウンロード", -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = ["href", "onClick"]
const _hoisted_23 = {
  key: 0,
  class: "sub1"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ダウンロード", -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 0,
  class: "modal-footer"
}
const _hoisted_28 = { class: "com_checkbox1" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "checkbox",
  class: "form-check-label"
}, "確認した", -1))
const _hoisted_30 = { class: "com_mgt10" }
const _hoisted_31 = {
  key: 0,
  class: "com_s_button1",
  disabled: ""
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "閉じる", -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text__item" }, "閉じる"),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text__item",
    "aria-hidden": "true"
  }, "閉じる")
], -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  key: 1,
  class: "modal-footer"
}
const _hoisted_37 = { class: "com_checkbox1" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "checkbox",
  class: "form-check-label"
}, " 次回以降表示しない ", -1))
const _hoisted_39 = { class: "com_mgt10" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text__item" }, "閉じる"),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text__item",
    "aria-hidden": "true"
  }, "閉じる")
], -1))
const _hoisted_41 = [
  _hoisted_40
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.isInitError)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "modal-container",
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (_ctx.errorMessage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.errorMessage), 1))
                    : _createCommentVNode("", true)
                ])
              ], 512),
              (_ctx.errorMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("button", {
                        class: "com_s_button1",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClosed && _ctx.onClosed(...args)))
                      }, _hoisted_8)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "modal-container",
              onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
            }, [
              (_ctx.isDataFetched)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_9, [
                      (_ctx.errorMessage)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.errorMessage), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("h1", null, _toDisplayString(_ctx.contentsData.title), 1),
                      _createElementVNode("div", {
                        class: "ql-editor",
                        innerHTML: _ctx.sanitizedContent
                      }, null, 8, _hoisted_11),
                      (_ctx.contentsData.contentsImgList.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentsData.contentsImgList, (imgFile) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: imgFile.rowNo
                              }, [
                                _createElementVNode("img", {
                                  src: `/${imgFile.imgPath}/${imgFile.imgName}`,
                                  alt: imgFile.imgExp
                                }, null, 8, _hoisted_13)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isExistsLinkAreaItem)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            (_ctx.contentsData.contentsLinkList.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  _hoisted_16,
                                  _createElementVNode("div", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentsData.contentsLinkList, (link) => {
                                      return (_openBlock(), _createElementBlock("ul", {
                                        key: link.rowNo,
                                        class: "list1"
                                      }, [
                                        _createElementVNode("li", null, [
                                          _createElementVNode("a", {
                                            href: `${link.url}`,
                                            class: "com_link1",
                                            target: "_blank",
                                            onClick: ($event: any) => (_ctx.regLinkClick(link.url))
                                          }, _toDisplayString(link.caption || link.url), 9, _hoisted_17)
                                        ])
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.contentsData.contentsTempFileList.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                  _createElementVNode("div", null, [
                                    _hoisted_19,
                                    _createElementVNode("a", {
                                      href: "#",
                                      class: "com_dl_button1",
                                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (
                    _ctx.downloadFiles(
                      _ctx.contentsData.categoryId,
                      _ctx.contentsData.contentsId,
                      ''
                    )
                  ), ["prevent"]))
                                    }, _hoisted_21)
                                  ]),
                                  _createElementVNode("div", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentsData.contentsTempFileList, (tmpFile) => {
                                      return (_openBlock(), _createElementBlock("ul", {
                                        key: tmpFile.rowNo,
                                        class: "list2"
                                      }, [
                                        _createElementVNode("li", null, [
                                          _createElementVNode("a", {
                                            href: `/${tmpFile.tempFilePath}/${tmpFile.tempFileName}`,
                                            class: "com_link1",
                                            target: "_blank",
                                            onClick: ($event: any) => (_ctx.regFileLinkClick(tmpFile.tempFileName))
                                          }, _toDisplayString(tmpFile.tempFileName), 9, _hoisted_22),
                                          (tmpFile.tempFileSize)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, " (" + _toDisplayString(tmpFile.tempFileSize) + ") ", 1))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("a", {
                                            href: "#",
                                            class: "com_dl_button2",
                                            onClick: _withModifiers(($event: any) => (
                        _ctx.downloadFiles(
                          _ctx.contentsData.categoryId,
                          _ctx.contentsData.contentsId,
                          tmpFile.tempFileName
                        )
                      ), ["prevent"])
                                          }, _hoisted_26, 8, _hoisted_24)
                                        ])
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ], 512),
                    (_ctx.isCheckPaternConfirm)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              id: "checkbox",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isChecked) = $event)),
                              onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onChangeCheckState && _ctx.onChangeCheckState(...args)))
                            }, null, 544), [
                              [_vModelCheckbox, _ctx.isChecked]
                            ]),
                            _hoisted_29
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            (!_ctx.isChecked)
                              ? (_openBlock(), _createElementBlock("button", _hoisted_31, _hoisted_33))
                              : (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  class: "com_s_button1",
                                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onClosed && _ctx.onClosed(...args)))
                                }, _hoisted_35))
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              id: "checkbox",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isChecked) = $event)),
                              onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onChangeCheckState && _ctx.onChangeCheckState(...args)))
                            }, null, 544), [
                              [_vModelCheckbox, _ctx.isChecked]
                            ]),
                            _hoisted_38
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("button", {
                              class: "com_s_button1",
                              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onClosed && _ctx.onClosed(...args)))
                            }, _hoisted_41)
                          ])
                        ]))
                  ], 64))
                : _createCommentVNode("", true)
            ]))
      ]))
    : _createCommentVNode("", true)
}